export default class FinanceModel {
  constructor(data) {
    this.id = data.id;
    this.creator = data.creator || null;
    this.credit_card_info = data.credit_card || [];
    this.ref_id = data.ref_id || null;
    this.vat = data.vat || null;
    this.irs = data.irs || null;
    this.withholding_tax = data.withholding_tax || null;
    this.payments_period = data.payments_period || null;
    this.status = data.status || null;
    this.details = data.details || null;
    this.ils_amount = data.ils_amount || null;
    this.attachment = data.attachment || "";
    this.user_id = data.user_id || null;
    this.invoice_number = data.invoice_number || null;
    this.invoice_date = data.invoice_date || null;
    this.purchase_method = data.purchase_method || null;
    this.projects = data.projects || null;
    this.category = data.category || null;
    this.currency_id = data.currency_id || null;
    this.purchase_date = data.purchase_date || null;
    this.due_date = data.due_date || null;
    this.purchase_details = data.purchase_details || null;
    this.amount = data.amount || null;
    this.created_at = data.created_at || null;
    this.updated_at = data.updated_at || null;
    this.log = data.log || [];
    this.user = data.user || [];
    this.types = data.types || [];
    this.reasons = data.reasons || [];
    this.status_id = data.status_id || null;
  }
}
